(function ($) {
  //$('[data-toggle="tooltip"]').tooltip()
  $('.input-info').tooltip({ boundary: 'window', 'placement': 'right' });

  $(document).ready(function () {
    changeFactory();
    $('#fc-specification').change(function () {
      $('#spec-factory-options').html('<div class="spinner-grow spinner-grow-sm mt-4" role="status"><span class="sr-only">Loading...</span></div>');
      $.ajax({
        url: window.sage.ajax_url,
        type: 'POST',
        data: {
          action: 'get_vehicle_spec_factory_resposne',
          vehicleType: $(this).val(),
        },
        success: function (data) {
          clearSelectedFactoryOpts();
          if (data) {
            $('#spec-factory-options').html(data);
            factoryOptExp();
          } else {
            $('#spec-factory-options').html('No Factory Options available');
          }
        },
        error: function (textStatus) {
          console.log(textStatus);
        },
      });
    });

    $('#tradeInForm').validate();
    $('#btnNext1').click(function () {
      if ($('#tradeInForm').valid()) {
        $('html, body').animate({ scrollTop: $('#tradeInForm').offset().top - 100 }, 600);
        $('#divStep1').hide();
        $('#btnNext1').hide();
        $('#divStep2').fadeIn();
        $('#btnEdit1').fadeIn();
        $('#btnNext2').fadeIn();
        $('#home-form-process-area ul li').eq(0).removeClass('active').next().addClass('active');
        $('#home-form-process-area ul li').eq(0).addClass('done').addClass('fa fa-check');
      } else {
        $('#tradeInForm').find(':input.error:first').focus();
        $('html, body').animate({
          scrollTop: $('#tradeInForm').find(':input.error:first').offset().top - 125,
        }, 600);
      }
    });

    $('#btnEdit1').click(function () {
      $('html, body').animate({ scrollTop: $('#tradeInForm').offset().top - 100 }, 600);
      $('#divStep1').fadeIn();
      $('#btnNext1').fadeIn();
      $('#divStep2').hide();
      $('#btnEdit1').hide();
      $('#btnNext2').hide();
      $('#home-form-process-area ul li').eq(1).removeClass('active').prev().addClass('active');
      $('#home-form-process-area ul li').eq(0).removeClass('done').removeClass('fa fa-check');
    });

    $('#btnNext2').click(function () {
      if (jQuery('#tradeInForm').valid()) {
        $('html, body').animate({ scrollTop: $('#tradeInForm').offset().top - 100 }, 600);
        $('#divStep2').hide();
        $('#btnNext2').hide();
        $('#btnEdit1').hide();
        $('#divConfirmation').fadeIn();
        $('#btnSubmit').fadeIn();
        $('#btnEdit2').fadeIn();
        $('#home-form-process-area ul li').eq(1).removeClass('active').next().addClass('active');
        $('#home-form-process-area ul li').eq(1).addClass('done').addClass('fa fa-check');
      } else {
        $('#tradeInForm').find(':input.error:first').focus();
        $('html, body').animate({
          scrollTop: $('#tradeInForm').find(':input.error:first').offset().top - 125,
        }, 600);
      }
    });

    $('#btnEdit2').click(function () {
      $('html, body').animate({ scrollTop: $('#tradeInForm').offset().top - 100 }, 600);
      $('#divStep2').fadeIn();
      $('#btnNext2').fadeIn();
      $('#btnEdit1').fadeIn();
      $('#divConfirmation').hide();
      $('#btnSubmit').hide();
      $('#btnEdit2').hide();
      $('#home-form-process-area ul li').eq(2).removeClass('active').prev().addClass('active');
      $('#home-form-process-area ul li').eq(1).removeClass('done').removeClass('fa fa-check');
    });

    $('#tradeInForm').submit(function (e) {
      if (jQuery('#tradeInForm').valid()) {
        $('#divLoading').show();
        e.preventDefault();
        $('#btnEdit2').prop('disabled', true);
        const btnLoading = $(this).find('.btn-loading').html();
        $(this).find('.btn-loading').addClass('spinner').text('submitting');
        $.ajax({
          type: 'POST',
          url: window.sage.ajax_url,
          data: $('#tradeInForm').serialize(),
          success: function (data) {
            if (data.substring(0, 7) == 'Sucess|') {
              var base_url = window.location.origin;
              window.location.href = base_url + '/form/trade-in-thank-you';
              return false;
            } else {
              $('#btnEdit2').prop('disabled', false);
              $(this).find('.btn-loading').html(btnLoading);
              alert('Error: ' + data);
            }
            $(this).find('.btn-loading').removeClass('spinner');
          },
        });
      }
    });
  });

  function changeFactory() {
    $(document).on('change', '.factory-option', function (e) {
      e.preventDefault();
      chkFactoryOpt($(this).val(), $(this).is(':checked'));
    });
  }

  /*eslint-disable */
  function chkFactoryOpt(val1, val2) {
    //selectedFactoryOpts
    var tmpArr1, tmpArr2, tmpArr3, tmpArr4, tmpStr5;
    var selectedFactoryOpts = document.getElementById('idSelectedFactoryOptIdStr').value;
    if (selectedFactoryOpts.replace(/ /gi, '') != '') tmpArr1 = selectedFactoryOpts.split('~');
    else tmpArr1 = new Array();
    tmpArr2 = val1.split('~');
    //selectedFactoryOptsTxt
    var selectedFactoryOptsTxt = document.getElementById('idSelectedFactoryOptTxtStr').value;
    if (selectedFactoryOptsTxt.replace(/ /gi, '') != '') tmpArr3 = selectedFactoryOptsTxt.split('~');
    else tmpArr3 = new Array();
    tmpArr4 = val1.split('~');
    if (val2 === true) {
      if (tmpArr1.length > 0) {
        tmpArr1.push(tmpArr2[0]);
        tmpArr3.push(tmpArr4[1]);
      } else {
        tmpArr1 = new Array(tmpArr2[0]);
        tmpArr3 = new Array(tmpArr4[1]);
      }
    } else {
      var index = tmpArr1.indexOf(tmpArr2[0]);
      if (index > -1) {
        tmpArr1.splice(index, 1);
        tmpArr3.splice(index, 1);
      }
    }
    var tmpStr1 = '';
    var tmpStr3 = '';
    var tmpArr5 = tmpArr3;
    if (tmpArr1.length > 0) {
      tmpArr1 = tmpArr1.sort();
      tmpStr1 = tmpArr1.join('~');
      tmpStr3 = tmpArr3.join('</li><li>');
      tmpStr5 = tmpArr5.join('~');
    }
    document.getElementById('idSelectedFactoryOptIdStr').value = tmpStr1;
    if (tmpStr3 != '') {
      document.getElementById('idSelectedFactoryOptTxtStr').value = tmpStr5;
    } else {
      document.getElementById('idSelectedFactoryOptTxtStr').value = '';
    }
  }

  /*eslint-enable */

  function clearSelectedFactoryOpts() {
    $('#idSelectedFactoryOptIdStr').val('');
    $('#idSelectedFactoryOptTxtStr').val('');
  }

  function factoryOptExp() {
    $('#idFactoryOptionsBtn').on('click', function () {
      var curState = document.getElementById('divFactoryOptions').style.display;
      if (curState == 'none') {
        document.getElementById('divFactoryOptions').style.display = 'block';
        document.getElementById('idFactoryOptionsBtn').innerHTML = 'Collapse';
      } else if (curState == 'block') {
        document.getElementById('divFactoryOptions').style.display = 'none';
        document.getElementById('idFactoryOptionsBtn').innerHTML = 'Expand';
      }
    })
  }
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/layouts/tradeIn.js